module.exports = __webpack_public_path__ + "img/realplayer_features05.424d41ab.svg";